import { render } from "./Coupons.vue?vue&type=template&id=2cc8bc56&scoped=true"
import script from "./Coupons.vue?vue&type=script&lang=js"
export * from "./Coupons.vue?vue&type=script&lang=js"

import "./Coupons.vue?vue&type=style&index=0&id=2cc8bc56&lang=css"
import "./Coupons.vue?vue&type=style&index=1&id=2cc8bc56&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=2&lang=css"

import exportComponent from "D:\\laragon\\www\\subeasy\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc8bc56"]])

export default __exports__